// ─────────────────────────────────────────────────────────────────────────────
// What every industry pack builds its job types with (2026-10-18).
//
// Moved verbatim from jobTypesUtils.js, where it built the Window & Door
// defaults alone. A pack that is seeded in the BROWSER at signup (Window &
// Door, Food & Beverage) mints its stage ids here, so every company owns its
// own: `stage_<ms>_<position>_<random>`. The SaaS vertical is seeded from
// server code and keeps stable readable ids instead (saasIndustryUtils.js).
//
// A PACK IMPORTS NOTHING BUT THIS FILE AND priceBookUtils.js. jobTypesUtils.js
// reads the registry for its Window & Door fallback, so a pack that imported
// jobTypesUtils would be an import cycle.
// ─────────────────────────────────────────────────────────────────────────────

export const stage = (name, category) => ({ name, category });

export const buildStages = (rows) =>
  rows.map((row, i) => ({
    id: `stage_${Date.now()}_${i}_${Math.random().toString(36).slice(2, 7)}`,
    name: row.name,
    category: row.category,
    order: i,
  }));
